import { colors } from "@/theme";

export const CARD_TITLE_OVERLAY_GRADIENT_LIGHT =
  "linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 25%, rgba(255, 255, 255, 0.6) 50%, #f5f5f5 100%)";

// The mascot's night navy rather than the brown-black it was: the wash sits
// over artwork on a navy page.
export const CARD_TITLE_OVERLAY_GRADIENT_DARK = `linear-gradient(180deg, rgba(7, 20, 46, 0) 0%, rgba(7, 20, 46, 0.4) 25%, rgba(7, 20, 46, 0.65) 50%, ${colors.layer1Dark} 100%)`;

/**
 * The wash that fades in over the title while the card is hovered: the blue
 * light the mascot is drawn in, coming up from the bottom of the card. Pale
 * sky in the light scheme, where the title is dark ink; deep blue in the dark
 * one, where it is white.
 */
export const CARD_TITLE_HOVER_GRADIENT_LIGHT =
  "linear-gradient(180deg, rgba(207, 235, 255, 0) 0%, rgba(207, 235, 255, 0.7) 45%, #CFEBFF 100%)";

export const CARD_TITLE_HOVER_GRADIENT_DARK =
  "linear-gradient(180deg, rgba(46, 144, 255, 0) 0%, rgba(11, 99, 214, 0.55) 50%, rgba(11, 42, 102, 0.95) 100%)";
